// モフトレチェック.
export const LOADING: string = 'MOFF_CHECK_LOADING';
export const SUCCESS: string = 'MOFF_CHECK_SUCCESS';
export const ERROR: string = 'MOFF_CHECK_ERROR';

// getMoffCheckLastDateで使用.
export const FINISH: string = 'MOFF_CHECK_FINISH';
export const START_LOAD: string = 'MOFF_CHECK_START_LOAD';

// TUG測定データテーブル.
export interface TUGTable {
  // Unique ID
  unique_id: string;
  // data_id
  data_id: string;
  // 時間.
  time: number;
  // 起立.
  stand_up: number;
  // 往路.
  out: number;
  // 往路ターン.
  out_turn: number;
  // 復路.
  in: number;
  // 復路ターン.
  in_turn: number;
  // 着席.
  sit: number;
  // 軌跡スコア.
  line_score: number;
  // 矩形面積スコア.
  square_score: number;
  // 角度変化量：前.
  front: number;
  // 角度変化量：後.
  back: number;
  // 角度変化量：左.
  left: number;
  // 角度変化量 ：右.
  right: number;
  // 測定開始時刻.
  started_at: string;
  // データ作成時刻.
  created_at: string;
  // データ更新時刻.
  updated_at: string;
}

// バランス測定データテーブル.
export interface BalanceTable {
  // Unique ID
  unique_id: string;
  // data_id
  data_id: string;
  // 時間.
  time: number;
  // 測定タイプ.
  /*
  左足　left_leg
  右足　right_leg
  両足  both_leg
  */
  measurement_type: string;
  // 軌跡スコア.
  line_score: number;
  // 矩形面積スコア.
  square_score: number;
  // 角度変化量：前.
  front: number;
  // 角度変化量：後.
  back: number;
  // 角度変化量：左.
  left: number;
  // 角度変化量 ：右.
  right: number;
  // 測定開始時刻.
  started_at: string;
  // データ作成時刻.
  created_at: string;
  // データ更新時刻.
  updated_at: string;
}

// TUG周期表の秒数.
export interface TUGTableSeconds {
  // 時間.
  time: number;

  // 起立.
  stand_up: number;
  // 往路.
  out: number;
  // 往路ターン.
  out_turn: number;
  // 復路.
  in: number;
  // 復路ターン.
  in_turn: number;
  // 着席.
  sit: number;
}

// 片足立ち立位の秒数(timeしか使わない).
export interface BalanceTableSeconds {
  // 時間.
  time: number;
}

// 施設.
export interface Institution {
  company_name: string;
  created_at: string;
  institution_email: string;
  institution_id: string;
  institution_name: string;
  institution_name_kana: string;
  institution_status: string;
  institution_sub: string;
  updated_at: string;
}


// WEBPACK FOOTER //
// ./src/constants/MoffCheck.tsx